import React from "react";
import { Link as RouterLink } from "react-router";
import { updateInIfExists } from "shared/src/util.mjs";
import { useUrlStringCreator } from "../url";
import { isGrantedAny } from "shared/src/roles.mjs";
import { useRoles } from "../context/AuthenticationTokenContext";
import { matchRoutes } from "../router";

/**
 * @param {import('react-router-dom').LinkProps} props
 */
const Link = React.forwardRef(function Link(props, ref) {
  const currentRoles = useRoles();
  const createUrlString = useUrlStringCreator();
  const updatedProps = updateInIfExists(props, ["to"], (to) =>
    createUrlString(to),
  );

  if (props.to != null) {
    const matches = matchRoutes(props.to);

    if (
      matches != null &&
      !matches.every((m) => isGrantedAny(currentRoles, m.route.handle?.anyRole))
    ) {
      return null;
    }
  }

  return <RouterLink ref={ref} {...updatedProps} />;
});

export default Link;
